import axios from 'axios'
import { saveAs } from 'file-saver'
import $http from '@/libs/axios'
import MultiVendorSectors from '@/constants/online-payment/vendor-sectors'
import FormsService from '@/services/forms-service'

let sectors: any = MultiVendorSectors
let cancelTokenSource: any = null

class BusinessAccountAPI {
  static async getAccountDetails(vendorId?: number, vendorSlug?: string, branchId?: string) {
    const query = FormsService.prepareQueryString({ vendor_slug: vendorSlug, branch_id: branchId }, true)
    return (await $http.get(`/vendor/view${vendorId ? `/${vendorId}` : ''}?${query || ''}`)).data
  }

  static async getAccountDetailsByVendorId(vendorId?: number, vendorSlug?: string, branchId?: string) {
    const query = FormsService.prepareQueryString({ vendor_slug: vendorSlug, branch_id: branchId }, true)
    return (await $http.get(`/vendor${vendorId ? `/${vendorId}` : ''}?${query || ''}`)).data
  }

  static async getSectors() {
    if (!sectors) {
      sectors = (await $http.get('/vendor/sectors')).data
    }
    return sectors
  }

  static async getVendors(slug?: string) {
    return (await $http.get(`/vendor/get-vendors${slug ? `/${slug}` : ''}`)).data
  }

  static async updateBusinessInfo(data: any) {
    return (await $http.post('/vendor/update', data, { headers: FormsService.MULTIPART_HEADER })).data
  }

  static async handleCustomTokenVendor(data: any) {
    return (await $http.post('/vendor/handle-custom-token-vendor', data)).data
  }

  static async cloneVendor(data: any) {
    return (await $http.post('/vendor/clone-vendor', data)).data
  }

  static async changeActiveVendor(data: any) {
    return (await $http.post('/vendor/change-active-vendor', data)).data
  }

  static async updateContactDetails(data: any) {
    return (await $http.post('/vendor/update', data, { headers: FormsService.MULTIPART_HEADER })).data
  }

  static async updateBusinessDocuments(data: any) {
    return (await $http.post('/vendor/update', data, { headers: FormsService.MULTIPART_HEADER })).data
  }

  static allowedCountries() {
    return ['KW', 'AE', 'SA', 'QA', 'BH', 'OM', 'EG', 'LB', 'JO']
  }

  static countriesWithoutIBAN() {
    return ['OM', 'EG']
  }

    static IBANs: any = {};

    static async validateIBAN(iban: string) {
      if (cancelTokenSource !== null) {
        cancelTokenSource.cancel()
      }

      if (typeof (BusinessAccountAPI.IBANs[iban] ?? null) === 'boolean') {
        return this.IBANs[iban]
      }
      cancelTokenSource = axios.CancelToken.source()
      try {
        BusinessAccountAPI.IBANs[iban] = (await axios.get(`https://openiban.com/validate/${iban}`, { cancelToken: cancelTokenSource.token }))?.data?.valid ?? true
      } catch (error) {
        console.warn(error)
        BusinessAccountAPI.IBANs[iban] = true
      }
      cancelTokenSource = null
      return BusinessAccountAPI.IBANs[iban]
    }

    // for the sales team
    static async initiateVendor(vendorId: number) {
      return (await $http.post(`/vendor/initiate/${vendorId}`)).data
    }

    static async rejectVendor(vendorId: number, notes: string) {
      return (await $http.post(`/vendor/reject/${vendorId}`, { notes })).data
    }

    static async getContractTemplate(branchId: number, slug: string) {
      const file = (await $http.get(`vendor/${branchId}/${slug}/download-contract-template`, { responseType: 'blob' })).data
      return saveAs(file, 'contract-template.pdf')
    }
}

export default BusinessAccountAPI
